import React from 'react';
import { SelectableLink, SelectableLinkContainer } from 'components/Link';
import { useSelector } from 'react-redux';
// import { isDev } from 'core/constants';
import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  top: 55vw;
  width: 100%;
`;

const Percentage = styled.div`
  margin-left: 2vw;
  margin-right: 1vw;
  width: 3vw;
  text-align: center;
`;

const HiddenDevOnlyButton = ({ onClick, children, percent }) => {
  // TODO: In true production the next line needs to be un-commented
  const showButtons = useSelector((state) => state.dev.showButtons);
  //   if (!isDev) return null -- todo -- take out in production
  if (!showButtons) return null;
  return (
    <SelectableLink onClick={onClick}>
      {children}{' '}
      {percent !== undefined && (
        <Percentage>{percent && Math.floor(percent) + '%'}</Percentage>
      )}
    </SelectableLink>
  );
};

export const HiddenDevOnlyOptions = ({
  goToNight,
  onComplete,
  restartRound,
  restartRoundNoIntro,
  percent,
}) => {
  return (
    <Container>
      <SelectableLinkContainer horizontal>
        {/* {restartRound && (
          <HiddenDevOnlyButton onClick={restartRound}>
            Reset
          </HiddenDevOnlyButton>
        )} */}
        {restartRoundNoIntro && (
          <HiddenDevOnlyButton onClick={restartRoundNoIntro}>
            Restart
          </HiddenDevOnlyButton>
        )}
        {goToNight && (
          <HiddenDevOnlyButton onClick={goToNight}>
            Go to night
          </HiddenDevOnlyButton>
        )}
        <HiddenDevOnlyButton onClick={onComplete} percent={percent}>
          Skip Wait
        </HiddenDevOnlyButton>
      </SelectableLinkContainer>
    </Container>
  );
};

export default HiddenDevOnlyButton;
